"use client"

import React from 'react';
import styles from "./Login.module.css";
import LoginForm from "@/components/LoginForm/LoginForm";

export default function Login() {

  return <div className={styles.container}><LoginForm/></div>

}
